'use es6';

import { Route, Switch } from 'react-router-dom';

// Only import and use "containers" for your route
import EndpointsList from './modules/EndpointsList/components/EndpointsList';
import ApiDeveloperDoc from './modules/Doc/components/ApiDeveloperDoc';
import CustomDeveloperDoc from './modules/Doc/components/CustomDeveloperDoc';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/",
      exact: true,
      component: EndpointsList
    }), /*#__PURE__*/_jsx(Route, {
      path: "/api",
      component: ApiDeveloperDoc
    }), /*#__PURE__*/_jsx(Route, {
      path: "/custom",
      component: CustomDeveloperDoc
    })]
  });
}